
import HtmlToReactParser from 'html-to-react'


export default function htmlRaw(htmlInput: string) {
    const htmlToReactParser = new HtmlToReactParser.Parser();
    return htmlToReactParser.parse(htmlInput, {}, {});
}